const intl = new Intl.NumberFormat("hu-HU", { style: "currency", currency: "HUF", maximumFractionDigits: 0 });

export function formatHuf(value: number) {
    return intl.format(value);
}